<template>
  <div id="CollectionPaymentSetting">
    <div class="main">
      <div class="title_bar">
        <div class="left">
          <div class="title">
            設定
          </div>
        </div>
        <div class="right" />
      </div>
      <el-tabs
        v-model="activeTab"
        class="setUpTabs"
      >
        <el-tab-pane
          label="內容物"
          name="content"
        >
          <div class="inputWrap">
            <p>新增內容物類型</p>
            <el-input
              v-model="contentInput"
              maxlength="10"
              placeholder="最多10個字元"
            />
            <el-button
              size="mini"
              plain
              @click="addItem('content')"
            >
              新增
            </el-button>
          </div>
          <p class="tableTitle">
            內容物類型列表
          </p>
          <el-table
            class="list"
            :data="contentList"
            empty-text="內容物類型列表"
            tooltip-effect="dark"
          >
            <el-table-column
              type="index"
              width="50"
            />
            <el-table-column
              label="內容物類型"
              prop="Name"
            />
            <el-table-column
              label="操作"
              width="180"
            >
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="danger"
                  plain
                  @click="delItem('content', scope.row.Id, scope.$index)"
                >
                  刪除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <TableLoading :is-loading="loading" />
        </el-tab-pane>

        <el-tab-pane
          label="物流"
          name="logistic"
        >
          <div class="inputWrap">
            <p>新增物流</p>
            <el-input
              v-model="logisticInput"
              maxlength="10"
              placeholder="最多10個字元"
            />
            <el-button
              size="mini"
              plain
              @click="addItem('logistic')"
            >
              新增
            </el-button>
          </div>
          <p class="tableTitle">
            物流列表
          </p>
          <el-table
            class="list"
            :data="logisticList"
            empty-text="目前無物流"
            tooltip-effect="dark"
          >
            <el-table-column
              type="index"
              width="50"
            />
            <el-table-column
              label="物流名稱"
              prop="Name"
            />
            <el-table-column
              label="操作"
              width="180"
            >
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="danger"
                  plain
                  @click="delItem('logistic', scope.row.Id)"
                >
                  刪除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <TableLoading :is-loading="loading" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import { apiCollectionPayment } from '@/api/CollectionPayment'
import TableLoading from '@/components/TableLoading'
export default {
  components: {
    TableLoading
  },
  data () {
    return {
      loading: true,
      activeTab: 'content',
      contentInput: '',
      contentList: [],
      logisticInput: '',
      logisticList: [],
      isSending: false // 防連點
    }
  },
  mounted () {
    this.getTypes()
  },
  methods: {
    // api回應新增刪除時，須回應目前type，其key與其前端不同，在此再做轉換
    filterType (type) {
      switch (type) {
        case 'content':
          return 'Contents'
        case 'logistic':
          return 'Logistics'
      }
    },
    async getTypes () {
      try {
        const res = await apiCollectionPayment.GetTypes()
        this.logisticList = res.data.Data.Lists[0].List
        this.contentList = res.data.Data.Lists[1].List
        this.loading = false
      } catch (err) {
        console.log(err)
      }
    },
    async addItem (type) {
      if (this.isSending) return

      const input = this[`${type}Input`]
      if (input === '') {
        this.$message({
          message: '請輸入類型名稱',
          type: 'warning'
        })
        return
      }

      // 防止輸入半形與全形空白
      if (input.includes(' ') || input.includes('　')) {
        this.$message({
          message: '名稱不得有空白',
          type: 'warning'
        })
        return
      }

      if (this[`${type}List`].some(item => item.Name === input)) {
        this.$message({
          message: '此類型已存在',
          type: 'warning'
        })
        return
      }

      this.isSending = true

      try {
        const params = {
          Type: this.filterType(type),
          TypeName: input
        }

        await apiCollectionPayment.PostType(params)

        this.getTypes()
        this[`${type}Input`] = ''
      } catch (err) {
        // 由api層處理錯誤，此處不做處理
        console.error(err)
      } finally {
        this.isSending = false
      }
    },
    async delItem (type, id) {
      if (this.isSending) return
      this.isSending = true

      try {
        await this.$confirm('類型刪除後將無法復原，確定刪除？', '提示', {
          confirmButtonText: '確定',
          cancelButtonText: '取消',
          type: 'warning'
        })
      } catch (err) {
        this.isSending = false
        // 按下取消鈕，不發送Api
        return
      }

      try {
        const params = {
          Type: this.filterType(type),
          TypeId: id
        }
        await apiCollectionPayment.DeleteType(params)
        this.getTypes()
      } catch (err) {
        console.log(err)
      } finally {
        this.isSending = false
      }
    }
  }
}
</script>

<style lang="sass" scoped>
#CollectionPaymentSetting
  +mainLayer
  ::v-deep .el-tabs
    &.setUpTabs
    +basicTabs
    .el-tabs__header
        margin: 0 0 0
    .el-tabs__active-bar
      height: 4px
    .el-tabs__nav-wrap::after
      height: 4px
    .el-tabs__item
      height: 46px
      min-width: 120px
      &:nth-child(3)
        min-width: 100px
    .el-tab-pane
      padding-top: 25px
      .inputWrap
        padding-left: 8px
        text-align: left
        .el-input
          margin-top: 8px
          margin-right: 20px
          width: 305px
      .tableTitle
        flex: 1
        color: $mainFontColor
        text-align: left
        margin-top: 37px
        margin-bottom: 18px
        font-weight: bold
  ::v-deep .el-table
    &.list
    +basicTable
    .el-table__row
      td
        height: 58px
</style>
